var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solana (SOL)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Solana (SOL)_2",
    cx: 24,
    cy: 24.5,
    r: 24,
    fill: "url(#paint0_linear_109_581)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Solana (SOL)_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Solana (SOL)_4",
    d: "M14.8779 30.1859C15.0442 30.0196 15.2729 29.9225 15.5154 29.9225H37.5104C37.9124 29.9225 38.1133 30.4076 37.8292 30.6917L33.4843 35.0367C33.3179 35.203 33.0893 35.3 32.8467 35.3H10.8517C10.4498 35.3 10.2488 34.8149 10.533 34.5308L14.8779 30.1859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Solana (SOL)_5",
    d: "M14.8779 13.9633C15.0512 13.797 15.2798 13.7 15.5154 13.7H37.5104C37.9124 13.7 38.1133 14.1851 37.8292 14.4692L33.4843 18.8142C33.3179 18.9805 33.0893 19.0775 32.8467 19.0775H10.8517C10.4498 19.0775 10.2488 18.5924 10.533 18.3083L14.8779 13.9633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Solana (SOL)_6",
    d: "M33.4843 22.0227C33.3179 21.8564 33.0893 21.7593 32.8467 21.7593H10.8517C10.4498 21.7593 10.2488 22.2444 10.533 22.5285L14.8779 26.8735C15.0442 27.0398 15.2729 27.1368 15.5154 27.1368H37.5104C37.9124 27.1368 38.1133 26.6517 37.8292 26.3676L33.4843 22.0227Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_581",
    x1: -86.5746,
    y1: -180.727,
    x2: -113.084,
    y2: 79.5299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885417,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/Solana.4588645a068bce71eb3d24fed70a8fd1.svg";
export { ForwardRef as ReactComponent };